function transformData(originalArray) {
    // Filter out incomplete or null entries
    const filteredArray = originalArray.filter(entry => entry && entry.date && entry.block_name);

    // Initialize an object to store transformed data
    const transformedData = {};

    // Define the convertDate function with padding for single digits
    const convertDate = (dateString) => {
        const dateLength = dateString.length;
    
        // Parse year, month, and day based on the length of the dateString
        let year, month, day;
    
        if (dateLength === 8) {
            month = dateString.substring(0, 2);
            day = dateString.substring(2, 4);
            year = dateString.substring(4, 8);
        } else if (dateLength === 7) {
            month = dateString.substring(0, 1).padStart(2, '0');
            day = dateString.substring(1, 3);
            year = dateString.substring(3, 7);
        } else {
            // Handle other formats if needed
            throw new Error('Invalid date format');
        }
      
        return new Date(`${year}-${month}-${day}`);
    };

    // Populate transformed data
    filteredArray.forEach(entry => {
      const block = entry.block_name;
      const date = convertDate(entry.date.toString());

      Object.keys(entry).forEach(key => {
        if (key !== "block_name" && key !== "date") {
          if (!transformedData[key]) {
            transformedData[key] = [];
          }

          const existingBlockData = transformedData[key].find(item => item.id === block);

          if (existingBlockData) {
            existingBlockData.data.push({ x: date, y: entry[key] ?? null });
          } else {
            transformedData[key].push({
              id: block,
              data: [{ x: date, y: entry[key] ?? null }]
            });
          }
        }
      });
    });
  
    return transformedData;
}

export { transformData };
